import { createElement, FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

const AnalyticsList: FC<Props> = ({ children, className }: { children: ReactNode; className?: string }) => {
  return <div className={className}>{children}</div>;
};

export default AnalyticsList;
